// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__h44ex","boxTitle":"Qualiphy_boxTitle__3fxc3","box":"Qualiphy_box__3RtvP","toggleWrap":"Qualiphy_toggleWrap__3vBmh"};